import { CheckListStageEntity } from 'backend-entity';

export type CrmPatchCheckListStageRequestDto = Partial<Pick<CheckListStageEntity, 'code' | 'name' | 'required' | 'order'>>;
